import { Route, Routes } from "react-router-dom";
import BoardLayout from "components/board/BoardLayout";
import NoticeBoardPageComponent from "components/board/NoticeBoardComponent";
import SystemBoardPageComponent from "components/board/SystemBoardComponent";

export default function BoardPage() {
  return (
    <>
      <BoardLayout>
        <Routes>
          <Route
            path="/notice/*"
            element={<NoticeBoardPageComponent />}
          ></Route>
          <Route
            path="/system/*"
            element={<SystemBoardPageComponent />}
          ></Route>
        </Routes>
      </BoardLayout>
    </>
  );
}
